export default __webpack_public_path__ + "static/media/001-mark.033e5d87.svg";